module.exports = __webpack_public_path__ + "static/media/Logo.74489cfb.svg";